var path = 'batch/bulkRestore/navigator/bulkRestoreNavigator.tpl.html';
var html = "<react-component name='activity-restore-navigator' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;